import { useEffect, useState, type Dispatch, type SetStateAction } from "react";
import { useSignUp } from "../../hooks/signUp/useSignUp";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/Sheet/Sheet";
import { format } from "date-fns";
import { EditSingletonSignUpForm } from "../../forms/signUp/EditSingletonSignUpForm";
import { EditMultiWeekSignUpForm } from "../../forms/signUp/EditMultiWeekSignUpForm";

const EditSignUpSheet = ({
  open,
  onOpenChange,
  data,
  setRotations,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  data: {
    rotation: any;
    session: any;
    enrollment?: any;
    preferences?: any;
  };
  setRotations: Dispatch<
    SetStateAction<{
      rotations: any[];
      sessions: any[];
      enrollments: any[];
      preferences: any[];
    }>
  >;
}) => {
  const [explorations, setExplorations] = useState<any[]>([]);

  const { loadExplorations, loading } = useSignUp();

  useEffect(() => {
    if (!data.session) return;
    loadExplorations(data.session._id, setExplorations);
  }, [data.session]);

  const onSuccess = ({
    enrollment,
    preferences,
  }: {
    enrollment?: any;
    preferences?: any;
  }) => {
    onOpenChange(false);
    enrollment &&
      setRotations((prev) => ({
        ...prev,
        enrollments: prev.enrollments.map((e) =>
          e._id === enrollment._id ? enrollment : e,
        ),
      }));
    preferences &&
      setRotations((prev) => ({
        ...prev,
        preferences: prev.preferences.map((p) =>
          p._id === preferences._id ? preferences : p,
        ),
      }));
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>
            Edit Submission for {data.session.name} on{" "}
            {format(data.rotation.date, "MMMM dd, yyyy")}
          </SheetTitle>
          <SheetDescription>
            {data.session.singleton
              ? "Update enrollment"
              : "Update preferences"}{" "}
            for {data.session.name} on{" "}
            {format(data.rotation.date, "MMMM dd, yyyy")}.
          </SheetDescription>
        </SheetHeader>
        {data.session.singleton ? (
          <EditSingletonSignUpForm
            data={{
              explorations,
              enrollment: data.enrollment,
              sessionId: data.session._id,
            }}
            loading={loading.loadExplorations}
            onSuccess={onSuccess}
          />
        ) : (
          <EditMultiWeekSignUpForm
            data={{
              explorations,
              preferences: data.preferences,
              sessionId: data.session._id,
            }}
            loading={loading.loadExplorations}
            onSuccess={onSuccess}
          />
        )}
      </SheetContent>
    </Sheet>
  );
};

export { EditSignUpSheet };
